import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { AuthShell, authInput, authButton } from "@/components/auth/AuthShell";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin") {
        toast.error("This account is not an administrator.");
        return;
      }
      toast.success("Welcome to the CRM");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow="Staff Access"
      title="Admin CRM"
      subtitle="Restricted to Aurelia administrators."
      image="https://images.unsplash.com/photo-1703565426315-4209c2e88eea?crop=entropy&cs=srgb&fm=jpg&q=85"
    >
      <form onSubmit={submit} className="space-y-4">
        <input type="email" required placeholder="Admin email" value={email} onChange={(e) => setEmail(e.target.value)} className={authInput} data-testid="admin-login-email" />
        <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={authInput} data-testid="admin-login-password" />
        <button type="submit" disabled={loading} className={authButton} data-testid="admin-login-submit">
          {loading ? "Authenticating…" : "Enter CRM"}
        </button>
      </form>
      <p className="mt-6 flex items-center gap-2 font-sans text-xs text-[var(--aur-text-2)]">
        <ShieldCheck size={14} className="text-gold" /> Role-based access · all actions are audited
      </p>
    </AuthShell>
  );
}
